import React from 'react';
import OrdersReturn from './OrdersReturn';
const OrdersReturnS = ({ color, ...props }) => (React.createElement(OrdersReturn, Object.assign({ color: color, size: 24 }, props)));
OrdersReturnS.displayName = 'OrdersReturnS'; // Fix for tsc
export default OrdersReturnS;
//# sourceMappingURL=OrdersReturnS.js.map